import { api } from 'api'
import { path } from 'ramda'

export enum PermissionEnum {
  ManageShifts = 'manageShift',
  ManageBonus = 'manageBonus',
  ManageRoles = 'manageRoles',
  PaymentAccess = 'paymentAccess',
  MessageWorker = 'messageWorker',
  WorkTimeAdjustment = 'workTimeAdjustment',
  ManageWorker = 'manageWorker',
  RequestSpecificWorker = 'requestSpecificWorker',
}

export type UserPermissions = {
  name: string
  description: string
} & {
  [key in PermissionEnum]: boolean
}

export async function getUserPermissions() {
  const data = await api.post(
    '/company/graphql_dispatch/user_permissions_6b5d424e',
    {}
  )

  return path(
    ['data', 'data', 'me', 'companyRolePermission'],
    data
  ) as UserPermissions
}
